import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";

const SECTIONS = [
    { id: "hero", label: "Hero" },
    { id: "evolution", label: "Internet Evolution" },
    { id: "reveal", label: "APIB Reveal" },
    { id: "backbone", label: "Living Backbone" },
    { id: "fabric", label: "The Living Fabric" },
    { id: "simulator", label: "Agent Simulator · type 'dream'" },
    { id: "products", label: "Four Pillars" },
    { id: "developers", label: "Conduit Access" },
    { id: "sandbox", label: "Infrastructure Sandbox" },
    { id: "command", label: "Operations Cockpit" },
    { id: "singularity", label: "Singularity Chamber" },
    { id: "connect", label: "Connect" },
];

export default function CommandPalette() {
    const [open, setOpen] = useState(false);
    const [q, setQ] = useState("");
    const nav = useNavigate();
    const loc = useLocation();

    useEffect(() => {
        const onKey = (e) => {
            if ((e.metaKey || e.ctrlKey) && (e.key === "k" || e.key === "K")) {
                e.preventDefault();
                setOpen(v => !v);
            }
            if (e.key === "Escape") setOpen(false);
        };
        window.addEventListener("keydown", onKey);
        return () => window.removeEventListener("keydown", onKey);
    }, []);

    if (!open) return null;
    const items = SECTIONS.filter(s => !q || s.label.toLowerCase().includes(q.toLowerCase()));

    const go = (id) => {
        setOpen(false);
        if (!loc.pathname.startsWith("/admin") && loc.pathname !== "/") {
            nav("/");
            setTimeout(() => document.getElementById(id)?.scrollIntoView({ behavior: "smooth" }), 80);
        } else if (loc.pathname.startsWith("/admin")) {
            nav("/");
            setTimeout(() => document.getElementById(id)?.scrollIntoView({ behavior: "smooth" }), 200);
        } else {
            document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
        }
    };

    return (
        <div className="fixed inset-0 z-[180] bg-void/80 backdrop-blur-xl flex items-start justify-center pt-32" onClick={() => setOpen(false)} data-testid="command-palette">
            <div className="w-full max-w-xl border border-signal/30 bg-black/90 shadow-[0_0_60px_rgba(255,176,0,0.15)]" onClick={e => e.stopPropagation()}>
                <div className="flex items-center gap-3 px-4 py-3 border-b border-border">
                    <span className="text-signal font-mono">›</span>
                    <input
                        autoFocus
                        value={q}
                        onChange={e => setQ(e.target.value)}
                        placeholder="Jump to section…"
                        className="flex-1 bg-transparent outline-none font-mono text-base text-ghost placeholder:text-muted"
                        data-testid="command-input"
                    />
                    <span className="text-[10px] font-mono text-muted uppercase tracking-[0.3em]">ESC</span>
                </div>
                <div className="max-h-80 overflow-y-auto">
                    {items.map(s => (
                        <button
                            key={s.id}
                            onClick={() => go(s.id)}
                            data-testid={`palette-${s.id}`}
                            className="w-full text-left px-4 py-3 font-mono text-sm hover:bg-signal/10 hover:text-signal transition-colors flex items-center gap-3"
                        >
                            <span className="text-muted">›</span>{s.label}
                        </button>
                    ))}
                    {items.length === 0 && <div className="px-4 py-6 font-mono text-xs text-muted">No matches.</div>}
                </div>
            </div>
        </div>
    );
}
